import React, { useState, useEffect } from 'react';

import isInBrowser from '@/helpers/isInBrowser';

import classNames from 'classnames';
import ReactPlayer from 'react-player/lazy';

import { PortfolioParagraphContentProps } from '@/helpers/getParagraphForDynamicPage';

import Play from '@/images/play.svg';

import './VideoPlayer.scss';

interface IProps extends PortfolioParagraphContentProps {
  link: string;
  previewTabIndex?: number;
  containerClass?: string;
  playerClass?: string;
}

export const VideoPlayer = ({
  link,
  previewTabIndex = 0,
  containerClass,
  playerClass = 'VideoPlayer_wrapper',
}: IProps) => {
  const [isClient, setIsClient] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);

  const handlePreviewClick = () => {
    setPlayVideo(true);
  };

  useEffect(() => {
    isInBrowser && setIsClient(true);
  }, []);

  return (
    <div className={classNames(containerClass, 'VideoPlayer_container')}>
      {link && isClient && (
        <ReactPlayer
          playing={playVideo}
          previewTabIndex={previewTabIndex}
          playIcon={<Play />}
          url={link}
          height="100%"
          width="792px"
          className={classNames(playerClass, 'VideoPlayer_box')}
          controls
          onClickPreview={handlePreviewClick}
        />
      )}
    </div>
  );
};
